/**
 * Replace placeholders in a string with provided values
 * Supports %s, %d (positional) and numbered placeholders like %1$s, %2$s, %1$d, %2$d
 *
 * @param template - The string template with placeholders
 * @param args - Values to replace placeholders with
 * @returns The formatted string
 *
 * @example
 * formatString("Hello %s", "world") // "Hello world"
 * formatString("%s and %s are required", "Name", "Email") // "Name and Email are required"
 * formatString("%2$s comes before %1$s", "first", "second") // "second comes before first"
 * formatString("%d Topics", "5") // "5 Topics"
 * formatString("%1$d/%2$d Steps", "3", "10") // "3/10 Steps"
 */
export function formatString(template: string, ...args: string[]): string {
  let index = 0;

  return template
    .replace(/%(\d+\$)?[sd]/g, (match, position) => {
      if (position) {
        // Numbered placeholder like %1$s, %2$s, %1$d, %2$d
        const num = Number.parseInt(position, 10) - 1;
        return args[num] ?? match;
      }
      // Sequential %s / %d placeholder
      return args[index++] ?? match;
    })
    .replace(/%%/g, '%');
}
